import DefaultLocationSelectModal from "../DefaultLocationSelectModal/DefaultLocationSelectModal.web";
import DefaultSeatSelectModal from "../DefaultSeatSelectModal/DefaultSeatSelectModal.web";
import WaitlistSelectModal from "../WaitlistSelectModal/WaitlistSelectModal.web";
import { ItemSelectModalProps } from "./ItemSelectModal.props";
import { useItemSelectModal } from "./useItemSelectModal";

const ItemSelectModal = (props: ItemSelectModalProps) => {
  const { isSeat, isLocation, hasWaitlist } = useItemSelectModal(props);

  return (
    <>
      {isSeat && !hasWaitlist && <DefaultSeatSelectModal {...props} />}
      {isLocation && !hasWaitlist && <DefaultLocationSelectModal {...props} />}
      {hasWaitlist && <WaitlistSelectModal {...props} />}
    </>
  );
};

export default ItemSelectModal;
